'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _creditCard = require('credit-card');

var _creditCard2 = _interopRequireDefault(_creditCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Every validator should be a boolean pure function with an 'errorMessage' property */

var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

var DATE_DDMMYYYY_REGEX = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;

var string = function string(value) {
  return typeof value === 'string' && value.length > 0 && !/^\s*$/.test(value);
};
string.errorMessage = 'Campo obbligatorio';

var text = function text(value) {
  return typeof value === 'string' && value.length > 0 && !/^\s*$/.test(value);
};
text.errorMessage = 'Campo inserito non valido';

var email = function email(value) {
  return EMAIL_REGEX.test(value);
};
email.errorMessage = 'Indirizzo email non valido';

var number = function number(value) {

  if (typeof value === 'string') {
    return (/^[0-9]+\.?([0-9]{1,2})?$/.test(value)
    );
  }

  return typeof value === 'number';
};
number.errorMessage = 'Consentiti solo caratteri numerici (usa il . in caso di decimali).';

var coordinate = function coordinate(value) {

  if (typeof value === 'string') {
    return (/^[0-9]+\.[0-9]+$/.test(value)
    );
  }

  return typeof value === 'number';
};
coordinate.errorMessage = 'Consentiti solo caratteri numerici (usa il . in caso di decimali)';

var integer = function integer(value) {

  if (typeof value === 'number' || typeof value === 'string') {
    return (/^[0-9]+$/.test(value.toString())
    );
  }

  return false;
};
integer.errorMessage = 'Consentiti solo caratteri numerici';

var phoneNumber = function phoneNumber(value) {

  /* The value should not be an integer, we need a string containing numbers. */
  if (typeof value === 'string') {
    return (/^\+?[0-9]{8,}$/.test(value)
    );
  }

  return false;
};
phoneNumber.errorMessage = 'Inserire un numero di telefono corretto';

var boolean = function boolean(value) {
  return typeof value === 'boolean';
};
boolean.errorMessage = 'Selezionare un elemento';

var date = function date(value) {
  if (typeof value !== 'string') {
    return false;
  }

  return DATE_DDMMYYYY_REGEX.test(value);
};
date.errorMessage = 'Inserire una data valida';

var time = function time(value) {
  if (typeof value !== 'string') {
    return false;
  }

  return (/^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(value)
  );
};
time.errorMessage = 'Inserire un orario valido';

var slot = function slot(value) {
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
    return false;
  }

  return time(value.open) && time(value.close);
};
slot.errorMessage = 'Inserire un orario valido';

var file = function file(value) {
  return value instanceof File;
};
file.errorMessage = 'Caricare un file valido';

var creditCardNumber = function creditCardNumber(value) {
  return _creditCard2.default.luhn(value);
};
creditCardNumber.errorMessage = 'Inserire un numero di carta di credito valido';

var creditCardExpiryMonth = function creditCardExpiryMonth(value) {
  return _creditCard2.default.isValidExpiryMonth(value);
};
creditCardExpiryMonth.errorMessage = 'Inserire un mese valido per la data di scadenza (formato mm)';

var creditCardExpiryYear = function creditCardExpiryYear(value) {
  return _creditCard2.default.isValidExpiryYear(value);
};
creditCardExpiryYear.errorMessage = 'Inserire un anno valido per la data di scadenza (formato aaaa)';

var creditCardCVC = function creditCardCVC(value) {
  return (/^[0-9]{3,4}$/.test(value)
  );
};
creditCardCVC.errorMessage = 'Inserire un codice di sicurezza valido';

exports.default = {
  string: string,
  text: text,
  email: email,
  phoneNumber: phoneNumber,
  number: number,
  coordinate: coordinate,
  integer: integer,
  boolean: boolean,
  date: date,
  time: time,
  slot: slot,
  file: file,
  creditCardNumber: creditCardNumber,
  creditCardExpiryMonth: creditCardExpiryMonth,
  creditCardExpiryYear: creditCardExpiryYear,
  creditCardCVC: creditCardCVC
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/lib/validators.js
// module id = 295
// module chunks = 0